import React from "react";

const RoleContext = React.createContext({role:""})

export default RoleContext



